import { render, staticRenderFns } from "./ListKRS.vue?vue&type=template&id=51b9be12"
import script from "./ListKRS.vue?vue&type=script&lang=js"
export * from "./ListKRS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports